module.exports = __webpack_public_path__ + "static/img/t1-1-1.a201152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-1-1.png
// module id = h71V
// module chunks = 1